import api from './api';

export const authService = {
  login: async (username, password) => {
    const response = await api.post('/auth/login', { username, password });
    if (response.data.success && response.data.data.token) {
      const token = response.data.data.token;
      const user = response.data.data.user;
      
      // Guardar de forma síncrona
      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(user));
      
      // Verificar que se guardó correctamente
      const savedToken = localStorage.getItem('token');
      if (savedToken !== token) {
        throw new Error('Error al guardar las credenciales');
      }
    }
    return response.data;
  },

  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  },

  getCurrentUser: () => {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  },

  isAuthenticated: () => {
    return !!localStorage.getItem('token');
  },

  verify: async () => {
    const response = await api.get('/auth/verify');
    return response.data;
  }
};
